<div class="boxWhite">
    <h4>CAMBIAR SUCURSAL MOVIL</h4>

    <button class="btn btnClose" (click)="close()">
        <img src="assets/img/icoClose.svg" alt="">
    </button>

    <div class="contModal">

        <div class="row">
            <div class="col-12">
                <ng-select placeholder="BUSCAR MOVIL..." [multiple]="false" [items]="listaMoviles"
                bindLabel="numeroInterno" [(ngModel)]="movilSeleccionado" [searchFn]="buscarMovilPorNumeroInternoYPatente">
                <ng-template ng-label-tmp let-item="item">
                    <span>{{ item.numeroInterno }}, {{item.patente}}, {{item.estado}}, {{item.sucursalNombreActual}}, {{ item.sucursalNombreFuturo ? item.sucursalNombreFuturo : 'No aplica' }}</span>
                </ng-template>
                <ng-template ng-option-tmp let-item="item" let-search="searchTerm" let-index="index">
                    <span>{{ item.numeroInterno }}, {{item.patente}}, {{item.estado}}, {{item.sucursalNombreActual}}, {{ item.sucursalNombreFuturo ? item.sucursalNombreFuturo : 'No aplica' }}</span>
                </ng-template>
              </ng-select>
            </div>
        </div>

        <br>
        <div class="row">
            <div class="col-sm-12">
                
                <div class="boxInsideModal bgLightGray mb-4 d-flex align-items-center justify-content-between">
                    <div class="d-flex flex-column justify-content-center">
                        <h6>Información del Movil</h6>
                        <p *ngIf="!movilSeleccionado" class="m-0 fw-medium">Seleccione un movil de la lista para ver su información</p>
                        
                        <div *ngIf="movilSeleccionado">
                            <p class="m-0 fw-medium">Número interno : {{movilSeleccionado.numeroInterno || ''}}</p>
                            <p class="m-0 fw-medium">Patente : {{movilSeleccionado.patente || ''}}</p>
                            <p class="m-0 fw-medium">Estado : {{movilSeleccionado.estado || ''}}</p>
                            <p class="m-0 fw-medium">Actual : {{movilSeleccionado.sucursalNombreActual || ''}}</p>
                            <p class="m-0 fw-medium">Futura : {{ movilSeleccionado.sucursalNombreFuturo || 'No aplica' }}</p>
                        </div>
                    </div>
                </div>
                
            </div>
        </div>

        <div class="row">
            <div class="col-sm-12 mb-4">
                <!-- listadoSucursalesDisponibles -->
                <ng-select placeholder="SELECCIONE TERMINAL" [(ngModel)]="sucursalSeleccionada" [multiple]="false"
                    bindLabel="nombre" [items]="listaSucursales">
                </ng-select>
            </div>
        </div>

    </div>
    <div class="footModal">
        <button *ngIf="tienePermisoCambiarSucursalMovil()" class="btn btnGray w-100" (click)="cambiarSucursal()">CAMBIAR SUCURSAL</button>
    </div>
</div>